import React, { PureComponent } from 'react';

/**
 * Components.
 */
import LandingSection from 'components/landing-section';
import LandingStep from 'components/landing-step';
import LandingStepArrow from 'components/landing-step-arrow';
import Button from 'components/button';

/**
 * Images
 */
import IconQuestion from 'assets/icons/question.svg';

/**
 * Style.
 */
import './fourth-section.scss';

class FourthSection extends PureComponent {
  render() {
    const { reference, goToAfiliation } = this.props;

    return (
      <LandingSection className="fourth-section" reference={reference}>
        <div className="fourth-section-content-wrapper">
          <div className="fourth-section-content-header">
            Como funciona
            <div className="fourth-section-content-header-question">
              <img src={IconQuestion} alt="" />
            </div>
          </div>
          <hr />
          <div className="fourth-section-content-sub-header">
            O processo para tornar-se um estudante Rosacruz consiste nos seguintes passos:
          </div>
          <div className="fourth-section-content">
            <LandingStep
              step={0}
              title="Proposta"
            >
              Preencha o formulário ao fim dessa página e finalize seu cadastro
            </LandingStep>

            <LandingStepArrow step={1} />
            <LandingStep
              step={1}
              title="Comitê de Afiliação"
            >
              Um comitê Rosacruz irá avaliar sua proposta de afiliação e
              aprová-la caso você já esteja apto
            </LandingStep>

            <LandingStepArrow step={2} />
            <LandingStep
              step={2}
              title="Contribuição"
            >
              Se sua proposta for aprovada, enviaremos um link para que você faça
              o pagamento da sua contribuição
            </LandingStep>

            <LandingStepArrow step={3} />
            <LandingStep
              step={3}
              title="Material de Estudo"
            >
              Em até 3 dias úteis você terá acesso ao seu material de estudos por meio digital, ou aguardar o prazo dos correios se impresso.
            </LandingStep>
          </div>
          <div className="fourth-section-button">
            <Button
              orange
              onClick={goToAfiliation}
            >
              QUERO ME AFILIAR
            </Button>
          </div>
        </div>
      </LandingSection>
    );
  }
}

export default FourthSection;
